import { render, staticRenderFns } from "./blockList.vue?vue&type=template&id=16027bad&scoped=true&"
import script from "./blockList.vue?vue&type=script&lang=js&"
export * from "./blockList.vue?vue&type=script&lang=js&"
import style0 from "./blockList.vue?vue&type=style&index=0&id=16027bad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16027bad",
  null
  
)

export default component.exports